/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 4278423f2d4b49c995f02b72f6b991c75ab885901c6cf092c0e0723e792fc445
 */
import {
  spacing,
} from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  align-items: center;
  display: flex;
  min-width: 0;
  width: 100%;

  &.layout-compact {
    gap: ${spacing(6)};
    justify-content: flex-end;
  }

  &.layout-default {
    justify-content: space-between;
  }
`
